const DEVICE_KEY = "device";
const COOKIE_MAX_AGE = 34560000; // 400 days in seconds, the longest browsers allow

// Devices not seen for this long no longer count toward the device limit
export const DEVICE_STALE_AFTER = 30 * 24 * 3600000; // 30 days in milliseconds

function readCookie(name: string) {
  const match = document.cookie
    .split(";")
    .map((el) => el.trim().split("="))
    .find(([key]) => key === name);

  return match?.[1];
}

function readStorage() {
  try {
    return localStorage.getItem(DEVICE_KEY);
  } catch {
    return null;
  }
}

export function saveDeviceId(deviceId: number) {
  document.cookie = `${DEVICE_KEY}=${deviceId};max-age=${COOKIE_MAX_AGE};path=/;SameSite=Lax`;

  try {
    localStorage.setItem(DEVICE_KEY, String(deviceId));
  } catch {
    // Storage blocked (eg. private mode), the cookie alone still works
  }
}

// The cookie is the original store, localStorage is a backup so clearing
// only cookies doesn't turn this browser into a new device
export function getDeviceId(): number | undefined {
  const value = readCookie(DEVICE_KEY) || readStorage();
  const deviceId = Number(value);

  if (!value || isNaN(deviceId)) return undefined;

  // Restore whichever store was missing and push the cookie expiry forward
  saveDeviceId(deviceId);
  return deviceId;
}

// Devices registered before lastSeen was tracked count as stale
export function isDeviceActive(device) {
  return Date.now() - (device?.lastSeen ?? 0) < DEVICE_STALE_AFTER;
}
